import { logger } from '@/lib/client'
import { TrackingProductsSchema } from '@/schemas/tracking.product'
import type { z } from 'zod'
import ga4 from './analytics/ga4'

export const PageImpression = async (
  properties: z.infer<typeof TrackingProductsSchema>,
): Promise<void> => {
  const event = 'Visualizou a página do produto'

  try {
    if (TrackingProductsSchema.parse(properties)) {
      ga4.viewItem(properties)
    }
  } catch (error) {
    logger(
      'TRACKING PAGE IMPRESSION',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}

export const ListImpression = async (properties: {
  type: string
  items: Array<z.infer<typeof TrackingProductsSchema>>
}): Promise<void> => {
  const event = 'Listagem de produtos'

  try {
    if (properties.items.length) {
      ga4.viewItemList(properties)
    }
  } catch (error) {
    logger(
      'TRACKING LIST IMPRESSION',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}
